import React from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { useState,useEffect, useRef  } from 'react';
import axios from 'axios';
import { useReactToPrint } from 'react-to-print';


const Formsixteen = () => {

  const [formSixteen, setformSixteen] = useState([]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
  const getformSixteen = async () => {
    try {
      const response = await axios.get("https://fakestoreapi.com/products?limit=10");
      const empData = response.data;
      setformSixteen(empData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getformSixteen();
  }, []);


  return (
    <div>

<Container>
      
      
                       
      <div className='container'>
          <div className='row '>
              <div className='col-lg-12 '>
                  <div className='row ' style={{display:"flex"}} >
                  </div>
                  <div className="row ">
                      <div className="col-lg-6 mt-4  ">
                          
                      </div>
                  </div>
           
                  <div className="row mt-4">
                  <div className="col-lg-12">
                      <div className="card"  ref={componentRef}>
                      <div className=""  style={{backgroundColor:"rgb(0,156,216)",color:'white'}}>
                          
                      </div>
                      <div className="card-body">
                          <div className="">
                          <ButtonGroup className="mb-2">
                                 {/* <Button>Copy </Button>
                                  <Button>Excel</Button> */}
                                   <Button onClick={handlePrint} >Download PDF</Button>
                                   {/* <Button>Column visibility</Button> */}
                                  </ButtonGroup>
                          </div>
                          <form>
                          <div className="card-body">
                              <div className='table-responsive'>
                              <table className="table table-bordered">
        
                              <thead>
                                  <tr>
                                  <th scope="col">Sl No</th>
                                  <th scope="col">Name</th>
                                  <th scope="col">User ID</th>
                                  <th scope="col">Form 16A</th>
                                  <th scope="col">Action</th>
                                  
                                 
                                  </tr>
                              </thead>

                              <tbody>
                              {
                                formSixteen.map((product, index) => (
                                  <tr key={index}>
                                    <td>{product.id}</td>
                                    <td>{product.title}</td>
                                    <td>{product.price}</td>
                                   
                                    <td>{product.title}</td>
                                   
                                   
                                    <td>
                                    <button className='btn btn-primary mx-2 mt-1'>Edit</button>
                                    <button className='btn btn-danger mx-2 mt-1'>Delete</button>
                                    </td>
                                  </tr>
                                ))
                                }
                              </tbody>

                              </table>
                              <nav aria-label="...">
<ul class="pagination">
  <li class="page-item disabled">
    <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
  </li>
  <li class="page-item active"><a class="page-link" href="#">1</a></li>
  <li class="page-item " aria-current="page">
    <a class="page-link" href="#">2</a>
  </li>
  <li class="page-item"><a class="page-link" href="#">3</a></li>
  <li class="page-item">
    <a class="page-link" href="#">Next</a>
  </li>
</ul>
</nav>
                              </div>
                              
                          </div>
                          {/* /.card-body */}
                          </form>
                      </div>
                      </div>
                  </div>
                  </div>






              

                

              </div>

          </div>

      
      </div>
      
    
    
  </Container>

    </div>
  )
}

export default Formsixteen;